import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { Link, useParams,useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

const QuestionList = () => {

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const topicId = searchParams.get("id");

  

  const [questions, setQuestions] = useState([]);
  const [topicName, setTopicName] = useState("");
  const [toggle, setToggle] = useState(false);

  const [formData, setFormData] = useState({
    question: "",
    answer_type: "",
    correct_answer: ""
  });

  const [answers, setAnswers] = useState([
  { answer: "", correct_answer: "" }
]);


const [editData, setEditData] = useState({
  id: "",
  question: "",
});

const handleAddRow = () => {
  setAnswers([...answers, { answer: "", correct_answer: "" }]);
};

const handleRemoveRow = (index) => {
  const updated = answers.filter((_, i) => i !== index);
  setAnswers(updated);
};

const handleAnswerChange = (index, field, value) => {
  const updated = [...answers];
  updated[index][field] = value;
  setAnswers(updated);
};

  useEffect(() => {
    fetchQuestions();
  }, []);

  const fetchQuestions = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/ques_list/${topicId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          }
        }
      );

      setQuestions(res.data.data.data);
      setTopicName(res.data.topic_name || "Topic");

    } catch (error) {
      toast.error("Failed to load questions");
    }
  };


  const handleEditSubmit = async (e) => {
  e.preventDefault();

  try {
    const res = await axios.post(
      API_BASE_URL + "/update_question",
      editData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

    if (res.data.status === "success") {
      toast.success(res.data.message);

      fetchQuestions();

      window.$('#editModal').modal('hide');
    }

  } catch (error) {
    toast.error(error.response?.data?.message || "Update failed");
  }
};




  const handleSubmit = async (e) => {
  e.preventDefault();

  try {

    const payload = {
      topic_id: topicId,
      question: formData.question,
      answer_type: formData.answer_type,
      correct_answer: formData.correct_answer,
      answers: formData.answer_type === "3" || formData.answer_type === "4"
        ? answers
        : []
    };

    // alert(JSON.stringify(payload, null, 2));

    const res = await axios.post(
      API_BASE_URL + "/add_question",
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

    if (res.data.status === "success") {

      toast.success(res.data.message);

      setToggle(false);
      fetchQuestions();

      setFormData({
        question: "",
        answer_type: "",
        correct_answer: ""
      });

      setAnswers([{ answer: "", correct_answer: "" }]);
    }

  } catch (error) {
    toast.error(error.response?.data?.message || "Something went wrong");
  }
};

  return (
    <>
      <ToastContainer />

      <div className="container-fluid">

        {/* Header */}
        <div className="card-header d-flex justify-content-between align-items-center">
          <span style={{ color: "blue", fontWeight: "600" }}>
            {topicName.toUpperCase()}
          </span>

          <button
            className="btn btn-primary"
            onClick={() => setToggle(!toggle)}
          >
            <i className="fe fe-plus mr-2" />
            {toggle ? "Close" : "Add Question"}
          </button>
        </div>

        {/* Toggle Form */}
        {toggle && (
          <div className="card mb-4">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Question</label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData.question}
                        onChange={(e) =>
                          setFormData({ ...formData, question: e.target.value })
                        }
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Answer Type</label>
                      <select
                        className="form-control"
                        value={formData.answer_type}
                        onChange={(e) =>
                          setFormData({ ...formData, answer_type: e.target.value })
                        }
                        required
                      >
                        <option value="">Select</option>
                        <option value="1">Yes / No</option>
                        <option value="2">True / False</option>
                        <option value="3">Single Choice</option>
                        <option value="4">Multi Choice</option>
                      </select>
                    </div>
                  </div>

                  {/* Yes/No or True/False Correct Answer */}
                  {(formData.answer_type === "1" || formData.answer_type === "2") && (
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Select Correct Answer</label>
                        <select
                          className="form-control"
                          value={formData.correct_answer}
                          onChange={(e) =>
                            setFormData({ ...formData, correct_answer: e.target.value })
                          }
                          required
                        >
                          <option value="">Select</option>
                          {formData.answer_type === "1" ? (
                            <>
                              <option value="1">Yes</option>
                              <option value="2">No</option>
                            </>
                          ) : (
                            <>
                              <option value="1">True</option>
                              <option value="2">False</option>
                            </>
                          )}
                        </select>
                      </div>
                    </div>
                  )}


                  {/* Single / Multi Choice */}
{(formData.answer_type === "3" || formData.answer_type === "4") && (
  <div className="col-md-12 mt-3">
    <table className="table table-bordered">
      <thead>
        <tr>
          <th>Answer</th>
          <th>Correct?</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {answers.map((row, index) => (
          <tr key={index}>
            <td>
              <input
                type="text"
                className="form-control"
                value={row.answer}
                onChange={(e) =>
                  handleAnswerChange(index, "answer", e.target.value)
                }
                required
              />
            </td>
            <td>
              <select
                className="form-control"
                value={row.correct_answer}
                onChange={(e) =>
                  handleAnswerChange(index, "correct_answer", e.target.value)
                }
                required
              >
                <option value="">Select</option>
                <option value="1">Is Correct</option>
                <option value="2">Is Wrong</option>
              </select>
            </td>
            <td>
              {index !== 0 && (
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => handleRemoveRow(index)}
                >
                  X
                </button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>

    <button
      type="button"
      className="btn btn-success"
      onClick={handleAddRow}
    >
      Add More
    </button>
  </div>
)}

                </div>

                <button className="btn btn-primary mt-3">
                  Save
                </button>
              </form>
            </div>
          </div>
        )}

        {/* Question Table */}
        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-hover table-striped">
                <thead>
                  <tr>
                    <th>Action</th>
                    <th>Question</th>
                    <th>Answer Type</th>
                  </tr>
                </thead>
                <tbody>
                  {questions.length > 0 ? (
                    questions.map((question, index) => (
                      <tr key={index}>
                        <td>
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <button
  className="btn btn-sm btn-outline-primary"
  data-toggle="modal"
  data-target="#editModal"
  onClick={() => setEditData(question)}
>
  <i className="fe fe-edit" />
</button>
                          <Link to={`/AnswerList?question_id=${question.id}`} className="btn btn-sm btn-outline-primary">
                            <i className="fe fe-eye " style={{ fontSize: "15px" }}/>
                          </Link>
                          </div>
                        </td>
                        <td>{question.question}</td>
                        <td>{question.answer_type}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center">
                        No Questions Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>



{/* //Edit question */}
<div className="modal fade" id="editModal" tabIndex="-1">
  <form onSubmit={handleEditSubmit}>
    <div className="modal-dialog">
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title">Edit Question</h5>
          <button type="button" className="close" data-dismiss="modal">
            ×
          </button>
        </div>

        <div className="modal-body">

          <div className="form-group">
            <label>Question</label>
            <input
              type="text"
              className="form-control"
              value={editData.question || ""}
              onChange={(e) =>
                setEditData({ ...editData, question: e.target.value })
              }
              required
            />
          </div>

          

        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            Close
          </button>

          <button type="submit" className="btn btn-primary">
            Save Changes
          </button>
        </div>

      </div>
    </div>
  </form>
</div>



      </div>
    </>
  );
};

export default QuestionList;